import React, { useState, useEffect } from 'react';
import { IconButton, Box } from '@chakra-ui/react';
import { ChevronUpIcon } from '@chakra-ui/icons';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <Box
      position="fixed"
      bottom="40px"
      right="40px"
      zIndex={1000}
      opacity={isVisible ? 1 : 0}
      visibility={isVisible ? 'visible' : 'hidden'}
      transition="all 0.3s ease-in-out"
    >
      <IconButton
        icon={<ChevronUpIcon boxSize={6} />}
        onClick={scrollToTop}
        size="lg"
        colorScheme="blue"
        bg="#000B8C"
        color="white"
        borderRadius="full"
        boxShadow="0 4px 12px rgba(0, 11, 140, 0.4)"
        _hover={{
          bg: "#000A7A",
          transform: "translateY(-4px)",
          boxShadow: "0 6px 16px rgba(0, 11, 140, 0.5)"
        }}
        _active={{
          bg: "#000968",
          transform: "translateY(-2px)"
        }}
        aria-label="Scroll to top"
        width="50px"
        height="50px"
      />
    </Box>
  );
};

export default ScrollToTop;
